Likes totales: {{ totalLikes }}
Retweets totales: {{ totalRetweets }}